import axios from 'axios';
import { API_URL } from 'configs';
export const FACE_APPROVAL_REQUEST = 'FACE_APPROVAL_REQUEST';
export const FACE_APPROVAL_SUCCESS = 'FACE_APPROVAL_SUCCESS';
export const FACE_APPROVAL_VALIDATION_ERROR = 'FACE_APPROVAL_VALIDATION_ERROR';
export const SHOW_SNACKBAR = 'SHOW_SNACKBAR';
export const HIDE_FACE_APPROVAL_FEILD_VALIDATION_ERROR = 'HIDE_FACE_APPROVAL_FEILD_VALIDATION_ERROR';
export const REDIRECT_TO_FACE_APPROVAL_LIST = 'REDIRECT_TO_FACE_APPROVAL_LIST';
export const FACE_APPROVAL_GET_SUCCESS = 'FACE_APPROVAL_GET_SUCCESS';
export const FACE_APPROVAL_DROPDOWN_LIST_SUCCESS = 'FACE_APPROVAL_DROPDOWN_LIST_SUCCESS';
export const FACE_APPROVAL_SERVER_SUCCESS = 'FACE_APPROVAL_SERVER_SUCCESS';
const SHOW_LOADER = 'SHOW_LOADER';
const HIDE_LOADER = 'HIDE_LOADER';

const showCommonLoader = (label = '') => ({
	type: SHOW_LOADER,
	common_loder_label: label
});
const hideCommonLoader = () => ({
	type: HIDE_LOADER
});

const faceApprovalRequest = () => ({
	type: FACE_APPROVAL_REQUEST
});

export const faceApprovalServerListSuccess = () => ({
	type: FACE_APPROVAL_SERVER_SUCCESS
});

const faceApprovalListSuccess = faceApprovalList => ({
	type: FACE_APPROVAL_SUCCESS,
	faceApprovalList: faceApprovalList
});

const faceApprovalFailure = notification => ({
	type: SHOW_SNACKBAR,
	snackbar_notification: notification,
	snackbar_notification_type: 'general_error'
});
const validationError = notification => ({
	type: FACE_APPROVAL_VALIDATION_ERROR,
	validation_error: notification
});
const tokenError = notification => ({
	type: SHOW_SNACKBAR,
	snackbar_notification: notification,
	snackbar_notification_type: 'token_expire'
});

const faceApprovalAddUpadteSuccess = (message, action, dispatch) => {
	dispatch(faceApprovalSuccessNotification(message));
	dispatch(redirectToFaceApprovalList());
};

export const redirectToFaceApprovalList = () => ({
	type: REDIRECT_TO_FACE_APPROVAL_LIST
});

const getFaceApprovalSuccess = (response, action) => ({
	type: FACE_APPROVAL_GET_SUCCESS,
	record: response,
	actionType: action
});

const faceApprovalSuccessNotification = message => ({
	type: SHOW_SNACKBAR,
	snackbar_notification: message,
	snackbar_notification_type: 'success'
});

export const hideFaceApprovalValidationError = feild_key => ({
	type: HIDE_FACE_APPROVAL_FEILD_VALIDATION_ERROR,
	feild_key: feild_key
});

/*
 * faceApproval dropdown list fetch methods
 */
const faceApprovalDropdownListSuccess = faceApprovalDropdownList => ({
	type: FACE_APPROVAL_DROPDOWN_LIST_SUCCESS,
	faceApprovalDropdownList: faceApprovalDropdownList
});

export const faceApprovalDropdownListFetch = (
	object_viewed_id,
	offices_ids,
	client_ids
) => {
	var token = localStorage.getItem('token');
	return dispatch => {
		dispatch(faceApprovalRequest());
		return axios(API_URL + 'faceApproval/getAllForDropdown', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
				Authorization: 'Bearer ' + token
			},
			data: {
				offices_ids: offices_ids,
				client_ids: client_ids,
				object_viewed_id: object_viewed_id
			}
		}).then(
			response => {
				dispatch(faceApprovalDropdownListSuccess(response.data));
			},
			error => {
				handleErrorResponse(error, dispatch);
			}
		);
	};
};

export const faceApprovalListFetch = (object_viewed_id = '') => {
	var token = localStorage.getItem('token');
	return dispatch => {
		dispatch(faceApprovalRequest());
		return axios(API_URL + 'faceApproval/getAll', {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
				Authorization: 'Bearer ' + token
			},
			params: { object_viewed_id: object_viewed_id }
		}).then(
			response => {
				dispatch(faceApprovalListSuccess(response.data));
			},
			error => {
				handleErrorResponse(error, dispatch);
			}
		);
	};
};

export const addFaceApproval = data => {
	var token = localStorage.getItem('token');
	return dispatch => {
		dispatch(faceApprovalRequest());
		return axios(API_URL + 'faceApproval/create', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
				Authorization: 'Bearer ' + token
			},
			data: data
		}).then(
			response => {
				faceApprovalAddUpadteSuccess(
					'Face Approval Added Successfully',
					'create',
					dispatch
				);
			},
			error => {
				handleErrorResponse(error, dispatch);
			}
		);
	};
};

export const updateFaceApproval = data => {
	var token = localStorage.getItem('token');
	return dispatch => {
		dispatch(faceApprovalRequest());
		return axios(API_URL + 'faceApproval/update/' + data.id, {
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
				Authorization: 'Bearer  ' + token
			},
			data: data
		}).then(
			response => {
				faceApprovalAddUpadteSuccess(
					'Face Approval Updated Successfully',
					'update',
					dispatch
				);
			},
			error => {
				handleErrorResponse(error, dispatch);
			}
		);
	};
};

export const getFaceApprovalById = (id, action) => {
	var token = localStorage.getItem('token');
	return dispatch => {
		dispatch(faceApprovalRequest());
		return axios(API_URL + 'faceApproval/getById/' + id, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
				Authorization: 'Bearer  ' + token
			}
		}).then(
			response => {
				dispatch(getFaceApprovalSuccess(response.data, action));
			},
			error => {
				handleErrorResponse(error, dispatch);
			}
		);
	};
};

export const deleteFaceApproval = (faceApprovalId, object_viewed_id) => {
	var token = localStorage.getItem('token');
	return dispatch => {
		dispatch(faceApprovalRequest());
		return axios(API_URL + 'faceApproval/delete/' + faceApprovalId, {
			method: 'DELETE',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
				Authorization: 'Bearer ' + token
			},
			data: {
				object_viewed_id
			}
		}).then(
			response => {
				dispatch(faceApprovalSuccessNotification('Face Approval deleted successfully'));
			},
			error => {
				handleErrorResponse(error, dispatch);
			}
		);
	};
};

// handling error reponse
const handleErrorResponse = (error, dispatch) => {
	try {
		if (error.response.status === 422 && error.response.data.error) {
			dispatch(validationError(error.response.data.error));
		} else if (error.response.status === 401 && error.response.data.error) {
			dispatch(tokenError(error.response.data.error.toString()));
		} else {
			let err = '';
			if (error.response.data.error) {
				err = error.response.data.error.toString();
			} else {
				err = error.response.status + ` ` + error.response.statusText;
			}
			dispatch(faceApprovalFailure(err));
		}
	} catch (e) {
		dispatch(
			faceApprovalFailure('Unable to perform action.Something went wrong')
		);
	}
};
